import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Sparkle, ArrowRight } from '@phosphor-icons/react';
import { useLanguage } from '../contexts/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DetailingUpsellBanner() {
  const { t } = useLanguage();
  const [eligible, setEligible] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/customer/upsell-eligibility`, { withCredentials: true });
        setEligible(!!r.data?.eligible);
      } catch { setEligible(false); }
    })();
  }, []);

  if (!eligible) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                className="px-4" data-testid="detailing-upsell-banner">
      <Link to="/detailing"
            className="block p-4 rounded-2xl bg-gradient-to-br from-[#FF5A00]/15 via-[#FFD700]/8 to-[#0ABAB5]/12 border border-[#FF5A00]/30 hover:border-[#FF5A00]/60 transition group">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <Sparkle size={18} weight="fill" className="text-[#FFD700]" />
              <p className="text-sm font-bold text-white">{t('upsellLiquidGlassTitle')}</p>
            </div>
            <p className="text-xs text-white/65 leading-relaxed">{t('upsellLiquidGlassBody')}</p>
          </div>
          <ArrowRight size={20} className="text-[#FF5A00] shrink-0 group-hover:translate-x-1 transition" />
        </div>
      </Link>
    </motion.div>
  );
}
